import { GlFilteredSearchSuggestion, GlIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { s__ } from '~/locale';
import { getIdFromGraphQLId, convertToGraphQLId } from '~/graphql_shared/utils';
import { TYPENAME_GROUP } from '~/graphql_shared/constants';
import BaseToken from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/filtered_search_bar/tokens/base_token.vue?vue3';
import groupsAutocompleteQuery from '~/graphql_shared/queries/groups_autocomplete.query.graphql';
import getGroupNamesByIdsQuery from '~/ci/catalog/graphql/queries/get_groups_by_ids.query.graphql';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
export default {
    name: 'GroupToken',
    components: {
        BaseToken,
        GlFilteredSearchSuggestion,
        GlIcon
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        active: {
            type: Boolean,
            required: true
        }
    },
    data () {
        const initialIds = [
            this.value.data
        ].flat().filter(Boolean);
        return {
            groups: [],
            allGroups: [],
            initialGroups: [],
            searchTerm: null,
            initialIds
        };
    },
    apollo: {
        initialGroups: {
            query: getGroupNamesByIdsQuery,
            variables () {
                return {
                    ids: this.initialIds.map((id)=>convertToGraphQLId(TYPENAME_GROUP, id))
                };
            },
            skip () {
                return !this.initialIds.length;
            },
            update (data) {
                return this.mapGroupNodes(data?.groups?.nodes);
            },
            result ({ data }) {
                if (!data?.groups?.nodes) return;
                this.updateAllGroups(this.initialGroups);
            },
            error () {
                createAlert({
                    message: s__('CiCatalog|There was an error fetching groups.')
                });
            }
        },
        groups: {
            query: groupsAutocompleteQuery,
            variables () {
                return {
                    search: this.searchTerm
                };
            },
            skip () {
                return this.searchTerm === null;
            },
            update (data) {
                return this.mapGroupNodes(data?.groups?.nodes);
            },
            result ({ data }) {
                if (!data?.groups?.nodes) return;
                this.updateAllGroups(this.groups);
            },
            error () {
                createAlert({
                    message: s__('CiCatalog|There was an error fetching groups.')
                });
            }
        }
    },
    computed: {
        loading () {
            return this.$apollo.queries.groups.loading;
        },
        groupNameMap () {
            return Object.fromEntries(this.allGroups.map((g)=>[
                    g.value,
                    g.text
                ]));
        },
        suggestions () {
            return this.searchTerm === null ? this.initialGroups : this.groups;
        }
    },
    methods: {
        mapGroupNodes (nodes) {
            return (nodes || []).map((group)=>({
                    value: String(getIdFromGraphQLId(group.id)),
                    text: group.fullName
                }));
        },
        updateAllGroups (groups) {
            groups.forEach((group)=>{
                if (!this.allGroups.some((g)=>g.value === group.value)) {
                    this.allGroups.push(group);
                }
            });
        },
        getActiveTokenValue (suggestions, data) {
            return suggestions.find((s)=>s.value === data) || this.allGroups.find((g)=>g.value === data);
        },
        getDisplayValue (selectedTokens) {
            return selectedTokens.map((id)=>this.groupNameMap[id] || id).join(', ');
        }
    }
};
